module.exports = __webpack_public_path__ + "img/faq_dcd_solutions.c115f1b5.png";